import React, {Component} from "react";
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { global } from './../../config.js';
import withRouter from './../withRouter';

import ReactPlayer from 'react-player/lazy'

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';

import ClipLoader from "react-spinners/ClipLoader";
import BarLoader from "react-spinners/BarLoader";


class Video extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,
            item: {},
            loading: true,
            error: false,
            show_modal_delete: false,
            show_modal_embed: false,
            saving: false,
            video: null,
            uploading: false,
            filename: ""
        };

        this.item = this.item.bind(this)
        this.handleCloseDelete = this.handleCloseDelete.bind(this)
        this.handleCloseEmbed = this.handleCloseEmbed.bind(this)
        this.delete = this.delete.bind(this)
        this.embed = this.embed.bind(this)
    }

    componentDidMount(){
        this.item()
    }

    item() {
        
        const requestOptions = {
            method: 'GET',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
        .then(res => res.json().then(
            (result) => {

                if (res.status === 200 && !result.error) {
                    this.setState({
                        item: result,
                        loading: false,
                        video: result.video
                    });
                } else {
                    if (result.error) {
                        this.setState({
                            error: result.error.message
                        });
                    } else {
                        this.setState({
                            error: "Произошла ошибка. Пожалуйста, попробуйте позже."
                        });
                    }
                }
                this.setState({
                    loading: false
                });
            }
        ))

    }


    delete() {

        this.setState({
            deleting: true,
            error: false
        })

        const requestOptions = {
            method: 'DELETE',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id + "/video", requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.setState({
                        video: null,
                    });
                } else if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                    });
                }

                this.setState({
                    deleting: false,
                    show_modal_delete: false
                });
            },
            (error) => {}
        ))
    }


    handleCloseDelete() {
        this.setState({
            show_modal_delete: false
        })
    }

    handleCloseEmbed() {
        this.setState({
            show_modal_embed: false
        })
    }

    handleFileChange = event => {
        const file = event.target.files[0]

        this.setState({
            uploading: true,
            error: false,
            filename: file.name
        })

        const formData = new FormData();
        formData.append('file', file, file.name);
            
        fetch(global.endpoint_api + '/items/' + this.state.id + "/video", {
          method: 'PUT',
          body: formData,
          headers: {
            'Authorization': 'Bearer ' + Cookies.get('session-acs'),
            "Access-Control-Allow-Origin": "*"
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.Location)
                this.setState({
                    uploading: false,
                    video: data.Location
                });
            else {
                this.setState({
                    uploading: false,
                    error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                });
            }
          })
          .catch((err) => {
            console.error(err)
            this.setState({
                uploading: false,
                error: err
            });
          });
    };

    embed() {

        let url = document.getElementById("value_url").value

        if (url === '') {
            this.setState({
                error: "Не указана ссылка"
            })
            return;
        }

        this.setState({
            saving: true,
            error: false,
            show_modal_embed: false
        })

            
        fetch(global.endpoint_api + '/items/' + this.state.id + "/video", {
          method: 'PUT',
          body: JSON.stringify({type: "rutube", url}),
          headers: {
            'Authorization': 'Bearer ' + Cookies.get('session-acs'),
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*"
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.Location)
                this.setState({
                    saving: false,
                    video: data.Location
                });
            else if (data.error) {
                this.setState({
                    error: data.error.message,
                    saving: false
                });
            } else {
                this.setState({
                    saving: false,
                    error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                });
            }
          })
          .catch((err) => {
            console.error(err)
            this.setState({
                saving: false,
                error: err
            });
          });
    };
    


    render() {

        let { item, video, loading, show_modal_delete, deleting, uploading, error, show_modal_embed, saving } = this.state

        return (
            <>
            <Row className="mb-4">
                <Col>
                    <Link to={"/items/" + this.state.id}>&larr; Назад</Link>
                </Col>
            </Row>
            <Row>
                <Col md={9} lg={6}>
                    <ClipLoader
                        loading={loading}
                        size={30}
                    />
                    {!item.title && !loading && (
                        <h4>Объект не найден или был удален</h4>
                    )}

                    {item.title && !loading && (
                        <>
                            <div className="mb-5">

                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h5><Image src="/images/icons/video.svg" width={20}/> Видео</h5>
                                            {video === null && !uploading && (
                                                <p className="mt-3 small truncate-text-lines">Не добавлено</p>
                                            )}
                                            {video != null && (
                                                <>
                                                 {video.startsWith("https://rutube.ru/video/") ? (
                                                   <div className="frame-container mb-3 mt-3">
                                                        <iframe
                                                            className="frame-video"
                                                            title="video"
                                                            src={video.replace("https://rutube.ru/video/", "https://rutube.ru/play/embed/")}
                                                            webkitAllowFullScreen
                                                            mozallowfullscreen
                                                            allowFullScreen>
                                                        </iframe>
                                                    </div>
                                                ) : (
                                                    <ReactPlayer
                                                        className="mt-4"
                                                        controls={true}
                                                        url={video}
                                                        width="100%"
                                                        height="100%"
                                                    />
                                                )}
                                                </>
                                                
                                            )}
                                        </div>

                                        

                                        <Row className="justify-content-between">

                                            <Col className="mb-4">
                                                {video === null && !uploading && (
                                                    <>
                                                        <label className="btn btn-sm btn-dark me-3 mb-2" htmlFor="file-upload">
                                                            Загрузить файл
                                                        </label>
                                                        <input
                                                            className="input-file"
                                                            type="file"
                                                            id="file-upload"
                                                            onChange={this.handleFileChange}
                                                            accept="video/*"
                                                        />
                                                    </>
                                                )}
                                                 
                                                <BarLoader color="#0b2621" loading={uploading}/>
                                                {uploading && (
                                                    <p className="mt-2 small truncate-text-lines">Загрузка<br />{this.state.filename}</p>
                                                )}
                                         
                                                {video === null && !uploading && (
                                                    <>
                                                        <Button variant="primary" size="sm" className="mb-2" onClick={() => this.setState({show_modal_embed: true})}>
                                                            Добавить из RuTube
                                                        </Button>
                                                    </>
                                                )}
                                         
                                            </Col>
                                        </Row>
                                    
                                    </div>
                                </div>

                            </div>

                            {video != null && (
                                <Link to="#" className="text-danger"onClick={() => this.setState({show_modal_delete: true})}>Удалить видео</Link>
                            )}

                            <Modal show={show_modal_delete} onHide={this.handleCloseDelete} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Удалить</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Вы действительно хотите удалить видео?</p>
                                </Modal.Body>
                                <Modal.Footer className="justify-content-between">
                                    <Button variant="light" disabled={deleting} onClick={this.handleCloseDelete}>
                                        Нет
                                    </Button>
                                    <Button variant="danger" disabled={deleting} onClick={this.delete}>
                                        Да
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={show_modal_embed} onHide={this.handleCloseEmbed} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Видео</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p className="mb-0">Вставьте ссылку на видео из RuTube</p>
                                    <p className="small">Например, https://rutube.ru/video/3ee525fc9d9dec34f1a054286bd9d970/</p>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Control type="text" placeholder="" id="value_url" />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer className="justify-content-between">
                                    <Button variant="light" disabled={saving} onClick={this.handleCloseEmbed}>
                                        Отмена
                                    </Button>
                                    <Button variant="dark" disabled={saving} onClick={this.embed}>
                                        Сохранить
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            
                        </>
                    )}

                    {error && (
                        <p className="text-danger">{error}</p>
                    )}
                    
                </Col>
            </Row>
            </>
        )

    }
}

export default withRouter(Video);